import { AspectRatio, MediaAsset, NotificationOverlay as NotificationOverlayProps } from 'libs/contentful/props';
import React from 'react';
import { NotificationOverlayDesktopPosition } from 'types/constants';
import Media from 'components/shared/Media/Media';
import NotificationOverlay from 'components/shared/NotificationOverlay/NotificationOverlay';
import { cn } from 'utils/styles';

export interface HeroImageProps {
  media: MediaAsset;
  aspectRatio?: AspectRatio;
  mobileMedia?: MediaAsset;
  mobileAspectRatio?: AspectRatio;
  notificationOverlay?: NotificationOverlayProps;
  notificationOverlayDesktopPosition?: NotificationOverlayDesktopPosition;
  priority?: boolean;
  isSlider?: boolean;
}

export enum HeroImageLocation {
  Default = 'Default',
  Bottom = 'Bottom',
  BetweenCtaAndDisclaimer = 'Between CTA and Disclaimer',
}

export const HeroImage = ({
  notificationOverlay: overlay,
  notificationOverlayDesktopPosition,
  priority,
  isSlider,
  ...mediaProps
}: HeroImageProps) => {
  return (
    <>
      <div
        className={cn(
          'image-container max-sm:max-w-[450px] relative sm:flex sm:justify-end overflow-hidden rounded-lg',
        )}>
        <Media
          className="object-contain"
          priority={isSlider ? priority : true}
          sizes="(max-width: 750px) 100vw, 600px"
          {...mediaProps}
        />
      </div>
      {overlay && overlay.display && (
        <NotificationOverlay
          notificationOverlayDesktopPosition={notificationOverlayDesktopPosition}
          description={overlay.image.description}
          fileName={overlay.image.fileName}
          url={overlay.image.url}
        />
      )}
    </>
  );
};
